import { render, staticRenderFns } from "./HorizontalChart.vue?vue&type=template&id=6c3dd036&scoped=true&"
import script from "./HorizontalChart.vue?vue&type=script&lang=js&"
export * from "./HorizontalChart.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalChart.vue?vue&type=style&index=0&id=6c3dd036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3dd036",
  null
  
)

export default component.exports